import * as roster from './roster'
import * as conversations from './conversations'
import * as groups from './groups'
import * as profile from './profile'
import * as search from './search'
import * as messages from './messages'

export default {
  roster,
  conversations,
  groups,
  profile,
  search,
  messages,
}
